// 配置管理模块
const CONFIG_KEY = 'app_config';

export interface AppConfig {
  apiBaseUrl: string;
  theme: 'light' | 'dark';
}

// 默认后端地址（可通过：设置页修改 / 或使用环境变量 REACT_APP_API_URL 覆盖）
const DEFAULT_API_BASE_URL = 'http://123.56.219.115:8000';

const LOCAL_API_URL_PATTERN = new RegExp('^https?:' + String.fromCharCode(47, 47) + '(localhost|127\\.0\\.0\\.1|10\\.0\\.2\\.2)(:\\d+)?\\/?$', 'i');
const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1', '::1', '10.0.2.2']);

function isLocalHost(hostname: string): boolean {
  return LOCAL_HOSTS.has(hostname);
}

function isLocalApiUrl(url: string): boolean {
  if (LOCAL_API_URL_PATTERN.test(url)) {
    return true;
  }
  try {
    return isLocalHost(new URL(url).hostname);
  } catch {
    return false;
  }
}

function isNativeRuntime(): boolean { return false; }

function getDefaultApiBaseUrl(): string {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  if (typeof window === 'undefined') {
    return '';
  }
  const hostname = window.location.hostname;
  if (isNativeRuntime() || isLocalHost(hostname) || window.location.protocol === 'file:') {
    return DEFAULT_API_BASE_URL;
  }
  return window.location.origin;
}

function getDefaultConfig(): AppConfig {
  return {
    apiBaseUrl: getDefaultApiBaseUrl(),
    theme: 'light',
  };
}

// 获取配置
export function getConfig(): AppConfig {
  const defaults = getDefaultConfig();
  try {
    const stored = localStorage.getItem(CONFIG_KEY);
    if (stored) {
      const parsed = JSON.parse(stored) as Partial<AppConfig>;
      const merged = { ...defaults, ...parsed } as AppConfig;

      // 兼容旧版本：仅当用户从未手动保存过配置时，才自动迁移 localhost 地址
      // 如果 localStorage 中有明确保存的 apiBaseUrl，则尊重用户的选择
      if (parsed.apiBaseUrl && isNativeRuntime() && isLocalApiUrl(parsed.apiBaseUrl)) {
        return { ...merged, apiBaseUrl: defaults.apiBaseUrl };
      }

      if (parsed.apiBaseUrl) {
        // 用户明确保存过，直接使用
        return merged;
      }

      // 用户未明确保存过 apiBaseUrl（旧版本遗留），且当前是 localhost，则迁移
      if (isLocalApiUrl(merged.apiBaseUrl) && defaults.apiBaseUrl !== 'http://127.0.0.1:8000') {
        return { ...merged, apiBaseUrl: defaults.apiBaseUrl };
      }

      return merged;
    }
  } catch (e) {
    console.error('读取配置失败:', e);
  }
  return defaults;
}

// 保存配置
export function saveConfig(config: Partial<AppConfig>): void {
  try {
    const current = getConfig();
    const newConfig = { ...current, ...config };
    localStorage.setItem(CONFIG_KEY, JSON.stringify(newConfig));
  } catch (e) {
    console.error('保存配置失败:', e);
  }
}

// 获取API基础URL
export function getApiBaseUrl(): string {
  // 优先使用环境变量
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  return getConfig().apiBaseUrl;
}

// Compatibility helpers used by existing pages; this client is always a browser.
export function isCapacitorApp(): boolean { return false; }
export function getPlatform(): 'web' { return 'web'; }
